<template>
    <LayoutDefault variant="black">
        <OrganismListContainer :is-loading="loaders['GET_FOLDERS']">
            <div class="flex items-baseline justify-end md:justify-between p-4 lg:px-12 py-5 lg:py-3">
                <p class="hidden md:block">{{ $t('pages.folders') }}</p>
            </div>
            <div v-for="(folder, index) in folders" :key="folder.id">
                <MoleculeCardFolder :class="{ '!border-b-0': index + 1 !== folders.length }" :folder="folder"/>
            </div>
        </OrganismListContainer>
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault.vue";
import OrganismFolderHero from "../components/folder/organisms/OrganismFolderHero.vue";
import TransitionFadeOut from "../transitions/TransitionFadeOut.vue";
import AtomFullPageLoader from "../components/global/atoms/AtomFullPageLoader.vue";
import {mapActions, mapState} from "vuex";
import OrganismFolderAbout from "../components/folder/organisms/OrganismFolderAbout.vue";
import OrganismFolderQuote from "../components/folder/organisms/OrganismFolderQuote.vue";
import OrganismEvent from "../components/event/organisms/OrganismEvent.vue";
import TransitionFade from "../transitions/TransitionFade.vue";
import MoleculeCardEventSkeleton from "../components/event/molecules/MoleculeCardEventSkeleton.vue";
import OrganismListContainer from "../components/global/organisms/OrganismListContainer.vue";
import MoleculeCardFolder from "../components/folder/molecules/MoleculeCardFolder.vue";

export default {
    name: "PageFolders",
    components: {
        MoleculeCardFolder,
        OrganismListContainer,
        MoleculeCardEventSkeleton, TransitionFade,
        OrganismEvent,
        OrganismFolderQuote,
        OrganismFolderAbout,
        AtomFullPageLoader, TransitionFadeOut,
        OrganismFolderHero,
        LayoutDefault
    },
    created() {
        this.getFolders();
    },
    methods: {
        ...mapActions('folder', ['getFolders'])
    },
    computed: {
        ...mapState('ui', {
            loaders: 'loaders',
        }),
        ...mapState({
            folders: state => state.folder.folders
        })
    }
}
</script>
